module.exports = __webpack_public_path__ + "6f36da2cf2a5e7bcc523e12065b835d7.svg";